<template>
    <div class="filter-container icon-filter-container">
        <template v-if="hasDynamicIconFilters">
            <icon-filter v-for="(icon, index) in dynamicIconFilters" :key="index" :data="icon"></icon-filter>
        </template>
        <template v-else>
            <fast-track-filter v-if="fasttrackenabled"></fast-track-filter>
            <water-splashes-filter v-if="watersplashesenabled"></water-splashes-filter>
        </template>
    </div>
</template>

<script>
import Vue from 'vue';
import Vuex from 'vuex';
import { mapState, mapGetters } from 'vuex';
import iconFilter from './iconFilter';

export default {
    components: {
        iconFilter
    },
    data: function() {
        return {
            iconFilters: []
        }
    },
    computed: {
        ...mapState('filters', ['fasttrackenabled', 'watersplashesenabled', 'activeFilters', 'dynamicIconFilters', 'hasDynamicIconFilters'])
    },
};

</script>